<template>
  <BannerTitle :msg="$t('awards')"></BannerTitle>
  <div class="flex justify-content-center">
    <div class="d-flex justify-content-center flex-wrap">
      <div v-for="group in scaleGroups" :key="group.id" class="mx-2">
        <!--         <input type="radio" class="btn-check" :id="'scale-' + group.id" autocomplete="off" /> -->
        <label class="btn awardsOption border-transparent" :class="{
          'active': scaleType == group.id,
          'border-round-left': group.id === 1,
          'border-round-right': group.id === scaleGroups.length
        }" :for="'scale-' + group.id" @click="changeScaleType(group.id)">
          {{ $t(group.scaleName ? group.scaleName[lang] : group.label) }}
        </label>
      </div>
      <div class="mx-2">
        <input type="radio" class="btn-check" name="options-outlined" autocomplete="off">
        <label class="btn awardsOption border-transparent border-round-right md:w-10rem"
          style="border-color: red !important;" @click="openModalCode">{{ $t('claimCode') }}</label>
      </div>
    </div>
  </div>
  <ProgressBar v-if="!validRequestDisable" class="progress-bar" :progressAP="getProgressBarValue(scaleType)"
    :limit="getProgressBarLimit(scaleType)" />
  <div v-if="!verifiedAccount && initialVerify" class="flex w-full justify-content-center">
    <div class="m-1 alert alert-warning  col-10 md:col-7 text-center" role="alert">
      <span class="fa fa-close"></span> {{ $t('accountNotVerified') }}
      <router-link to="/profile" aria-current="page" href="/">{{ $t('profile')
      }}</router-link>
    </div>
  </div>

  <!-- <img class="img-bg" :src="bgImagebod" />-->
  <Spinner v-if="validRequestDisable"></Spinner>
  <div v-if="!validRequestDisable" class="card-scale-container pt-6 px-6 d-flex flex-wrap justify-content-center gap-6">
    <CardAward v-for="card in cards.filter(c => c.groupScale === scaleType)" :key="card.scaleKey"
      :quantity="card.quantity" :nameItem="card.nameItem" :description="card.description"
      :descriptionItem="card.descriptionItem" :items="card.items" :image="card.image" :number="card.number"
      :msg="card.msg" :scaleVal="card.scaleVal" :claimed="card.claimed"
      :verifiedAccount="verifiedAccount || dateAccountOld" @click="selectedTab(card.scaleKey)"
      :class="tabSelected === card.scaleKey ? 'selectedTab' : ''" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2 tab1" />
  </div>

  <div class="tabs mb-10" id="tabs">
    <div v-if="!tabSelected" id="tabDefault"
      class="modal-selected-tab header-title-text pt-6 container flex justify-content-center">
      <span style="font-size: 30px;">{{ $t('selectScale') }}</span>
    </div>

    <NewEscala v-for="(scale, index) in cards" :key="index" :item="scale.items" :imageVertical="scale.imageVertical"
      :scaleKey="scale.scaleKey" :ids="scale.ids" :images="scale.images" :tabSelected="tabSelected === scale.scaleKey"
      :image="scale.image" :title="scale.title" :groupName="scale.groupName" :setNames="scale.setNames"
      :chooseOption="scale.chooseOption" :description="scale.description" :scaleVal="rangeScale[index]"
      :quantity="scale.quantity" :customQty="scale.customQty" :claimed="rangeClaimed[index]"
      :verifiedAccount="verifiedAccount || dateAccountOld" :scaleId="scale.scaleId"
      :class="tabSelected === scale.scaleKey ? 'selectedTab' : ''" />

  </div>
  <form v-if="showClaimModal" class="modal-overlays">
    <div class="modals">
      <div class="modal-content" style="padding:none;">
        <div class="modal-header border-bottom" :style="style" style="border-radius: 8px;padding:12px">
          <h1 class="modal-title fs-5" id="exampleModalLabel"></h1>
          <button @click="closeModal" type="button" class="btn-close" aria-label="Close"></button>
        </div>
        <div class="my-5" v-if="loadingClaim">
          <Spinner class="my-3" :dark="true" :isLoading="true"></Spinner>
          <span style="color: black;">{{ $t('validatingCode') }}</span>
        </div>
        <div v-if="!loadingClaim">
          <div v-if="codeStatusClaim == 'success'" class="text-success" style="text-align: center;padding: 2%">
            <font-awesome-icon class="my-4" :icon="['fas', 'circle-check']" beat size="7x" />
            <span style="color:black">
              <h5>{{ $t('codeClaimedSuccess') }}</h5>
            </span>
          </div>
          <div v-if="codeStatusClaim == 'error'" style="text-align: center;padding: 2%; color: #ed4337;">
            <font-awesome-icon class="my-4" :icon="['fas', 'ban']" beat size="7x" />
            <span style="color:black">
              <h5>{{ $t('codeClaimedError') }}</h5>
            </span>
          </div>
          <div v-if="codeStatusClaim == ''">
            <div class="modal-body flex justify-content-left  justify-content-center" style="padding:12px">
              <span style="color:black">
                <h5>{{ $t('setCodeToClaim') }}</h5>
                <input id="code" autocomplete="off" class="form-control" maxlength="15" minlength="12"
                  :class="form.code != '' && form.code.length >= 12 ? ' is-valid' : 'is-invalid'" v-model="form.code"
                  :placeholder="$t('insertTextField')" />
              </span>
            </div>
            <div class="flex justify-content-end m-2">
              <button :disabled="!(form.code != '' && form.code.length >= 12)" @click="sendVerification" type="button"
                class="ml-2 btn rounded-pill"
                style="background : linear-gradient(to right, #212121, #141414); color: white">
                <span class="button-custom-gf-2">{{ $t('validate') }}</span>
              </button>
              <button @click="closeModal" type="button" class="ml-2 btn rounded-pill"
                style="background : linear-gradient(to right, #212121, #141414); color: white">
                <span class="button-custom-gf-2">{{ $t('close') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
// @ is an alias to /src

import BannerTitle from '@/components/banner-title/BannerTitle'
import CardAward from '@/components/forms/awards/CardAward'
import ProgressBar from '@/components/forms/awards/ProgressBar'
import { ref } from "vue";
import imageScale1 from '@/assets/images/1x/confuso.png'
import imageScale2 from '@/assets/images/1x/saludando.png'
import imageScale3 from '@/assets/images/1x/enojado.png'
import imageScale4 from '@/assets/images/1x/riendo.png'
import imageScale5 from '@/assets/images/1x/euforico.png'
import NewEscala from '@/components/modal/NewEscala';
import service from '@/mixins/service.js'
import Spinner from '@/components/spinner/Spinner'
import { useRoute, useRouter } from 'vue-router';
export default {
  name: 'AwardsMPView',
  mixins: [service],
  components: {
    CardAward,
    BannerTitle,
    ProgressBar,
    Spinner,
    NewEscala,

  },
  setup() {
    const showClaimModal = ref(false);
    const loadingClaim = ref(false);
    const verifiedAccount = ref(false);
    const initialVerify = ref(false);
    const dateAccountOld = ref(false);
    const codeStatusClaim = ref('');
    const scaleGroups = ref([]);
    let lang = ref('')
    lang.value = localStorage.getItem('language');
    if (lang.value === 'br') {
      lang.value = 'pt';
    }
    const form = ref({
      code: ''
    });

    const getScaleGroups = () => {
      return scales.value.map((group, index) => {
        const mpAmountKey = ['mpAmount', 'mpAmountSecond', 'mpAmountThird', 'mpAmountQuart', 'mpAmountFifth', 'mpAmountSixth','mpAmountSeventh'][index] ?? 'mpAmount';
        const labelKey = ['scaleAward', 'scaleSecond', 'scaleThird', 'scaleQuart', 'scaleFifth', 'scaleSixth', 'scaleSeventh'][index] ?? 'scaleAward';
        return {
          id: index + 1,
          groupName: group.groupName,
          scaleName: group.scaleName,
          label: labelKey,
          mpAmountKey,
        }
      });
    };

    const sendVerification = async () => {
      loadingClaim.value = true;
      // codeStatusClaim.value = 'success';
      try {
        const data = {
          path: '/auth/claimPromotionCode',
          data: { code: form.value.code },
          method: 'POST',
          headers: { 'Content-type': 'application/json; charset=UTF-8' }
        }
        const resp = await service.methods.callService(data)
        if (resp.statusCode == 200) {
          codeStatusClaim.value = 'success';
        } else {
          codeStatusClaim.value = 'error';
        }
      } catch (error) {
        codeStatusClaim.value = 'error';
        //console.log(error)
      }
      loadingClaim.value = false;

    }
    const accountVerified = async () => {
      const verifiedJS = JSON.parse(localStorage.getItem('vfa') || "false");
      if (!verifiedJS) {
        const data = {
          path: '/auth/getVerifyParameter',
          method: 'GET',
        }
        const resp = await service.methods.callService(data)
        if (resp) {
          verifiedAccount.value = resp.isVerify;
          dateAccountOld.value = new Date(resp.created_at) < new Date('2024-09-22T05:00:00');
        }
        initialVerify.value = true;
      } else {
        verifiedAccount.value = verifiedJS;
        initialVerify.value = true;
      }
    }
    accountVerified();
    const closeModal = () => {
      showClaimModal.value = false;
      codeStatusClaim.value = '';
      form.value.code = '';
    }
    const openModalCode = () => {
      showClaimModal.value = true;
    }
    let scaleType;
    const route = useRoute().query;
    const router = useRouter();
    const listAvailableScales = [1, 2, 3, 4, 5, 6, 7];
    if (route.scale) {
      try {
        const routS = parseInt(route.scale);
        if (listAvailableScales.includes(routS)) {
          scaleType = ref(parseInt(route.scale));
        } else {
          router.push({ path: router.currentRoute.value.path, query: { scale: 1 } });
          scaleType = ref(1);
        }
      } catch (e) {
        //console.log('Invalid query')
        scaleType = ref(1);
      }
    } else {
      scaleType = ref(1);
    }
    let imgScale1 = ref(imageScale1);
    let imgScale2 = ref(imageScale2);
    let imgScale3 = ref(imageScale3);
    let imgScale4 = ref(imageScale4);
    let imgScale5 = ref(imageScale5);
    let tabSelected = ref('');
    let mpAmount = ref(0);
    let mpAmountQuart = ref(0);
    let mpAmountFifth = ref(0);
    let scales = ref([]);
    let scaleItems = ref([]);
    let groupLimits = ref({});
    const changeScaleType = (scaleSelected) => {
      scaleType.value = scaleSelected;
      tabSelected.value = null;
      const newQuery = { ...router.currentRoute.value.query }; // Clone existing query
      newQuery['scale'] = scaleSelected;
      if (router.currentRoute.value.path) {
        router.push({ path: router.currentRoute.value.path, query: newQuery });
      }
    }
    let mpAmountSecond = ref(0);
    let mpAmountThird = ref(0);
    let mpAmountSixth = ref(0);
    let mpAmountSeventh = ref(0);
    let rangeScale = ref([]);
    let rangeClaimed = ref([]);
    let validRequestDisable = ref(false)
    let viewTab1Second = ref(false)
    let viewTab2Second = ref(false)
    let viewTab3Second = ref(false)
    let viewTab4Second = ref(false)
    let viewTab5Second = ref(false)
    let viewTab6Second = ref(false)
    let viewTab7Second = ref(false)
    let viewTab8Second = ref(false)
    let viewTab9Second = ref(false)
    let viewTab10Second = ref(false)
    let viewTab1Third = ref(false)
    let viewTab2Third = ref(false)
    let viewTab3Third = ref(false)
    let viewTab4Third = ref(false)
    let viewTab5Third = ref(false)
    let viewTab6Third = ref(false)
    let viewTab7Third = ref(false)
    let viewTab8Third = ref(false)
    let viewTab9Third = ref(false)
    let viewTab10Third = ref(false)
    let viewTab1Quart = ref(false)
    let viewTab2Quart = ref(false)
    let viewTab3Quart = ref(false)
    let viewTab4Quart = ref(false)
    let viewTab5Quart = ref(false)
    let viewTab6Quart = ref(false)
    let viewTab7Quart = ref(false)
    let viewTab1Fifth = ref(false)
    let viewTab2Fifth = ref(false)
    let viewTab3Fifth = ref(false)
    let viewTab4Fifth = ref(false)
    let viewTab5Fifth = ref(false)
    let viewTab6Fifth = ref(false)
    let viewTab7Fifth = ref(false)
    let user = ref({})
    let serviceForm = ref({});
    let cards = ref([])
    user.value = JSON.parse(localStorage.getItem('user'))
    const selectedTab = (tab) => {
      tabSelected.value = tab;
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 500);
    }
    const topPage = () => {
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0
    }
    function getMaxValuePerGroup(scales) {
      const groupLimits = {};

      scales.forEach((group, index) => {
        const allValues = Object.values(group.scales).map(scale => scale.value ?? 0);
        const maxValue = Math.max(...allValues);
        groupLimits[index + 1] = maxValue; // porque el grupo 1 es el primero
      });

      return groupLimits;
    }
    function buildAwardCards(scales, rangeScale, rangeClaimed, itemMap) {
      const cards = []
      let index = 0
      let groupScale = 1
      for (const group of scales) {
        const groupName = group.groupName
        const groupScales = group.scales

        for (const scaleKey in groupScales) {
          const data = groupScales[scaleKey]
          const flatIds = Array.isArray(data.ids[0]) ? data.ids.flat(2) : data.ids
          const items = itemMap.filter(item => flatIds.includes(item.item_id))
          cards.push({
            scaleKey,
            groupName,
            groupScale,
            ids: data.ids,
            setNames: data.setNames ?? false,
            nameItem: data && data.name?.[lang.value] || (items[0]?.item_name?.[lang.value]) || 'Unknown Item',
            descriptionItem: items[0]?.secondary_description?.[lang.value] ?? '',
            description: data && data.description?.[lang.value] || '',
            image: `/images/scales/${groupName}.png`,
            images: data.images ?? false,
            imageVertical: data.imageVertical ?? false,
            number: index + 1,
            msg: `${data.value} MP`,
            scaleVal: rangeScale[index],
            claimed: rangeClaimed[index],
            quantity: Array.isArray(data?.quantity) ? data.quantity[0] ?? 1 : data?.quantity ?? 1,
            chooseOption: data.chooseOption ?? false,
            customQty: data.customQty ?? false,
            items
          })

          index++
        }
        groupScale++
      }
      return cards
    }


    const createContactForm = async () => {
      validRequestDisable.value = true
      try {
        const data = {
          path: '/auth/getScalesByAccount',
          data: serviceForm.value,
          method: 'POST',
          headers: { 'Content-type': 'application/json; charset=UTF-8' }
        }
        const resp = await service.methods.callService(data)
        mpAmount.value = resp.mpAmount;
        mpAmountSecond.value = resp.mpAmountSecond;
        mpAmountThird.value = resp.mpAmountThird;
        mpAmountQuart.value = resp.mpAmountQuart;
        mpAmountFifth.value = resp.mpAmountFifth;
        mpAmountSixth.value = resp.mpAmountSixth;
        mpAmountSeventh.value = resp.mpAmountSeventh;
        rangeScale.value = resp.rangeScale;
        rangeClaimed.value = resp.rangeClaimed;
        scales.value = resp.scales;
        scaleItems.value = resp.scaleItems;
        cards.value = buildAwardCards(resp.scales, resp.rangeScale, resp.rangeClaimed, resp.scaleItems);
        scaleGroups.value = getScaleGroups();
        groupLimits.value = getMaxValuePerGroup(resp.scales);
        ///   Validation claim scale 
        validRequestDisable.value = false
      } catch (error) {
        validRequestDisable.value = false
      }

    }
    createContactForm()
    topPage()
    const getProgressBarValue = (scaleId) => {
      const keyMap = {
        1: mpAmount.value,
        2: mpAmountSecond.value,
        3: mpAmountThird.value,
        4: mpAmountQuart.value,
        5: mpAmountFifth.value,
        6: mpAmountSixth.value,
        7: mpAmountSeventh.value
      };
      return keyMap[scaleId] ?? 0;
    };
    const getProgressBarLimit = (scaleType) => {
      return groupLimits.value[scaleType] ?? 60000;
    };
    //console.log(rangeScale.value[25])
    return {
      lang,
      scales,
      cards,
      scaleItems,
      scaleType,
      scaleGroups,
      changeScaleType,
      getProgressBarValue,
      getProgressBarLimit,
      imgScale1,
      imgScale2,
      imgScale3,
      imgScale4,
      imgScale5,
      viewTab1Second,
      viewTab2Second,
      viewTab3Second,
      viewTab4Second,
      viewTab5Second,
      viewTab6Second,
      viewTab7Second,
      viewTab8Second,
      viewTab9Second,
      viewTab10Second,
      viewTab1Third,
      viewTab2Third,
      viewTab3Third,
      viewTab4Third,
      viewTab5Third,
      viewTab6Third,
      viewTab7Third,
      viewTab8Third,
      viewTab9Third,
      viewTab10Third,
      viewTab1Quart,
      viewTab2Quart,
      viewTab3Quart,
      viewTab4Quart,
      viewTab5Quart,
      viewTab6Quart,
      viewTab7Quart,
      selectedTab,
      tabSelected,
      mpAmount,
      mpAmountSecond,
      mpAmountThird,
      mpAmountSixth,
      mpAmountQuart,
      validRequestDisable,
      rangeScale,
      rangeClaimed,
      listAvailableScales,
      showClaimModal,
      loadingClaim,
      sendVerification,
      codeStatusClaim,
      accountVerified,
      verifiedAccount,
      openModalCode,
      closeModal,
      form,
      initialVerify,
      dateAccountOld,
      viewTab1Fifth,
      viewTab2Fifth,
      viewTab3Fifth,
      viewTab4Fifth,
      viewTab5Fifth,
      viewTab6Fifth,
      viewTab7Fifth,
      mpAmountFifth,
    }
  },
}
</script>
<style scoped>
.img-bg {
  padding-left: 15%;
  width: 85%;
  height: 80%;
}

.awardsOption {
  background-color: #212121;
  color: white;
  border: none;
  font-weight: 500;
  border-radius: 0;
  transition: background-color 0.3s;
}

.awardsOption.active {
  background-color: #e9952e;
  color: white;
}

.chrismasOption {
  position: relative;
  border-radius: 0px;
  --bs-btn-color: #ffffffa9;
  --bs-btn-bg: #321464;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #D8182E;
  --bs-btn-active-border-color: transparent;
  --bs-btn-border-color: transparent;
  font-weight: 500;
}

.chrismasOption::before {
  content: '';
  display: block;
  position: absolute;
  top: -7px;
  left: -3px;
  right: 0;
  height: 23px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAXCAYAAACS5bYWAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABFpJREFUeNrUV0tIo1cUvpkYjQ4xxSA6DxuNqG0dtaUKOgs3s6i0dFd3pSsXdjeIixakiGA34sZuXCkoONLFwJTK4GMYLYXg29gatTpiXurkbd7vv9/5ub+IxuhA7eiFQ5Kbc8/57ne/e87/ywRBYLdl3GG3aNwqsLJ0k0tLS+fmcnNzWUVFBVMoFGx2djarvLxcm5OTw+bm5iytra2xc4ExNjY27iqVyvvwK6CpeDzuCYVC1urq6qDA9UcfPp+PHR4esmAwKK6tr68/l5/8rgQ2Ozub1dbWyiYmJooaGxt/VqvV38jlchX9l0qlwoFA4DWS/RKLxRxFRUVf5+XlPcaaT2AP0sVPJBL2SCRiAPBpu93+vKamZo/Ae71eZjabWV1dXVqw7CKwp43ksrCw8Bhg7MJ/PLDZ5PHx8cz29vYT5JGD/bSYLgTrcDgYdk6siSc6NjZWDaAe4ZoHQL+cmZnRpZPnhWDpD8kw7uKo9ML/NMCsd2tr61vkzboMrEyv138M7TyLRqMWMBsX3sMgaZhMpp+AR5EJrCocDpuEGzKg4x8khs+CVWxubvZfR9JkMik4nU7BarUKLpeLmLsKuwIqTLynp4fqmIzASrqQT09Pf1VVVfX0KsWZ6uHBwQHTaDSsoKAgo6/H4xHLEcrVyRwuEisrKzs5XrrIVAVwiUVDKRRrL+YI32ewdVhMApuHWvcj6vids6J2u90MF4yBHUZNgKoEBaRBQalJqFSqtJfUYrGIlQX+ydXVVTN+u0tKSjQNDQ1axJVl2iTypebn55d7e3v/kqoDgZU1NTU9LCws/Py0M+2ekuGincxJ3yF+18jIyHJLS0slQJUWFxczrBeBE0vE5tHRkbixlZWVfSR8gTX/0P5gH7S1tX3Z3t7+BW8qAvwSfr8/jA0EIRM/qoFtampqbW9vTw+XA+ojUruVd3Z2tvb19T2TQFEim81GgVJoCvvj4+NLOJZgaWmpemdn5y3a6BbcnJDAw8HBwac6ne6eqCW5XDwB3qVSqM9/DAwMUNy/eVLabT7sI25qwgujThCBhWE+mAt2yNc4SQKSZrOQQE1HS22VJkmPAGTr7+//fX19fRk+Zgq0trbGeFAKEAQT98BSqKOj47vm5uaa/Px8JeIk4GcaHh6eWlxcfAU/A8xG67BxAX3fwdcbYUpSDJ06Z49Ak8ZC3OL8f3YiA4PBYKdLQ2AJ9OTk5GpXV9cQiCVh79M94QtlPLDUE/1gPNrd3f0W33W4cBoco48zQuy/IZYAMnGqlSc4c66L9JruQUaSARXeT8HGKzxAqFBekni6+h46+pMzGiJGMgTOJh1yU/KNEGDvZWvfBawkA9ppwGg0mrRa7SOI2g+gxOgbJIpdFpj72PnxSnPX8vqRxTURgBQWKisrH+GThOm+CtAzoK/9/Uiqq/6hoaHfdnd3jaOjo7/yY7yxbwqkWy3sQzpS2C6YirwvUJk0y7hurfyGRrnduPGvAAMASmo8wzeVwfsAAAAASUVORK5CYII=) no-repeat -2% 0,
    url(data:image/png;base64,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) no-repeat 20% 0,
    url(data:image/png;base64,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) no-repeat 70% 0,
    url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAXCAYAAACFxybfAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAodJREFUeNrsVb1rWlEUv2pN/GqspKRSKFYXWzEloIWif0Fn6dJChQ7OQil0qd3EzcEpg0OgdHDr4CQODk7VRlLMEIVqApX4We0zflR9/Z1Ui4T34ksaaAYP/Hzc673n/M6550PG8zz73yKjn0wm83fDYDAwo9HINBrNnwOQg4MDs0ql2lQqlfdAWont7ng8Pjw+Ps44nc4G1pI9EXWaSOzt7TGO42aH5Pv7+08ajUZ0MBiUeXEZd7vdL5VK5fX29rZ+5tQiEmdxKrlcjsEYczgcynK5/BKKv/IXFNz/XiqVXkHdjUuRIA9SqdRD8or/R8Ez9fr9fqHVakUR4c2z0REjIQuHw2ZcrPBXLCA0RHTezEdHjIQqkUhEr9I4HOILhQLf6/VoOUFEvDMiQiToDx1Cdz+bzZ6bUFarlel0OkkVUK/XWbvdPoVer5fh3ntsfwJ+CJ2XA4p0Op1bpBgJyxDehQQ6nQ5DZXHBYDBZq9V+EhFUndnr9drEqoc2bwJbwGPgtohuVSwWe2Gz2TZMJpNgRKi6qtUqg2EWj8dTgUDgo0KhWPN4PC70EvXOzs67fD6/S6kiRIKeZA1YJ2MiJNbdbvfTUCjkV6vVK2hcDF8GI2w0GrGTkxM2HA5PDxaLxSOfz/cWEfk81X0XIMMFgJJ/srBjCgk8IdcfuVyuZ36//7nFYtkQyAMumUzuRiKRD0jMFLa+AZOpYwqgB/ziBVqmVBKUO7eAB/R0WG/Z7XaTVqtdbTabHJL6EK2djBaBPHA0NSqpbUsiMUeEBgpF4Q5AbZrmSJ/yEWgBTaBNHl9kdkgmMUeG7qwAq9PqovceTA3zlxlgsuswyuXsGsiSxJLEkoSY/BZgAEjRodi+uBruAAAAAElFTkSuQmCC) no-repeat 100% 0;
}

.progress-bar {
  width: 100%;
  padding-left: 10%;
  padding-right: 10%;
}

.tab1 {
  transition: transform .2s;
  /* Animation */
}

.tab1:hover {
  transform: scale(1.3);
  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.selectedTab {
  transform: scale(1.15);
}

.modal-overlays {
  position: fixed;
  top: 0;
  z-index: 9999;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(209, 204, 204, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-scale-container {
  margin-bottom: 5em;
}

.modals {
  width: 469px;
  background-color: white;
  color: white;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-align: center;
}
</style>
